
export async function getAllJiraProjects(token) {
    const url = `api/jira-projects`;
    const response = await fetch(url,{
        headers: {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json'
        }
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch Boards: ${response.status}`);
    }
    const data = await response.json();
    return data;
}


